import { parseJsonObject } from "./json";

export function parseAgentPlan(content: string): Map<string, string> {
  try {
    const parsed = parseJsonObject(content) as {
      tasks?: Array<{ agentId?: string; objective?: string }>;
    };
    return new Map(
      (parsed.tasks ?? [])
        .filter(
          (task): task is { agentId: string; objective: string } =>
            typeof task?.agentId === "string" &&
            Boolean(task.agentId.trim()) &&
            typeof task.objective === "string" &&
            Boolean(task.objective.trim()),
        )
        .map((task) => [task.agentId.trim(), task.objective.trim()]),
    );
  } catch {
    return new Map();
  }
}

export function hasDependencyCycle(
  agents: Array<{ id: string; dependsOn: string[] }>,
): boolean {
  const visiting = new Set<string>();
  const visited = new Set<string>();
  const byId = new Map(agents.map((agent) => [agent.id, agent]));
  const visit = (id: string): boolean => {
    if (visiting.has(id)) return true;
    if (visited.has(id)) return false;
    visiting.add(id);
    for (const dependency of byId.get(id)?.dependsOn ?? []) {
      if (byId.has(dependency) && visit(dependency)) return true;
    }
    visiting.delete(id);
    visited.add(id);
    return false;
  };
  return agents.some((agent) => visit(agent.id));
}
